import PropTypes from 'prop-types';

const Loader = ({ isLoading, fallback, children }) => (isLoading ? fallback : children);
Loader.propTypes = {
  isLoading: PropTypes.bool,
  fallback: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
Loader.defaultProps = {
  isLoading: false,
  fallback: () => 'Loading...',
};

export default Loader;
